import { apiSlice } from './apiSlice';

export type EntityLookupType = 'application' | 'route';

export type EntityLookupItem = {
  id: number;
  primaryLine: string;
  secondaryLine?: string | null;
  tertiaryLine?: string | null;
};

export type EntityLookupParams = {
  type: EntityLookupType;
  q?: string;
  id?: number;
  limit?: number;
  offset?: number;
};

export type EntityLookupResponse = {
  items: EntityLookupItem[];
  hasMore: boolean;
  totalCount: number;
};

export const entityLookupApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    lookupEntities: builder.query<EntityLookupResponse, EntityLookupParams>({
      query: ({ type, q, id, limit, offset }) => {
        const params = new URLSearchParams({ type });
        if (q != null && q.trim()) params.append('q', q.trim());
        if (id != null) params.append('id', String(id));
        if (limit != null) params.append('limit', String(limit));
        if (offset != null) params.append('offset', String(offset));
        return `/lookup/entities?${params.toString()}`;
      },
      transformResponse: (response: { data?: EntityLookupResponse }) =>
        response.data ?? { items: [], hasMore: false, totalCount: 0 },
    }),
  }),
});

export const { useLookupEntitiesQuery, useLazyLookupEntitiesQuery } = entityLookupApi;
